import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import VerificationRequest from "./VerificationRequest";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";

type Props = {
  external_reference: string;
  getUserVerificationRequests?: any;
};

class VerificationRequestContainer extends React.Component<Props> {
  render() {
    return (
      <>
        <BOGraphQLLoader data={this.props.getUserVerificationRequests!}>
          <VerificationRequest
            user={this.props.getUserVerificationRequests.user}
          />
        </BOGraphQLLoader>
      </>
    );
  }
}

const getUserQuery = graphql<any, Props>(
  gql`
    query details($external_reference: ID) {
      user(external_reference: $external_reference) {
        external_reference
        verification_request_history {
          status
          type
          created_at
          updated_at
          error_reason
        }
      }
    }
  `,
  {
    name: "getUserVerificationRequests",
    options: (props: Props) => {
      return {
        variables: {
          external_reference: props.external_reference,
        },
      };
    },
  }
);

const VerificationRequestContainerWithData = getUserQuery(
  VerificationRequestContainer
);
export { VerificationRequestContainerWithData, VerificationRequestContainer };
